export default __webpack_public_path__ + "static/media/decoration_pools_traits.9ac3eccd.svg";